import { Voltage } from '../../../../../../domain/Voltage';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class VoltageEvaluation {
  private readonly ruleName = 'Lv_EnergyConsumer_Voltage';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(voltage: number): EvaluationResultType<Voltage> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(rule?.value, voltage);
    const value = new Voltage(voltage);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
